import { render, staticRenderFns } from "./debug.vue?vue&type=template&id=1ea6a4f9&"
import script from "./debug.vue?vue&type=script&lang=ts&"
export * from "./debug.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports